<template>
  <div>
    <el-form ref="feedFlowForm" :model="feedFlowInfo">
    <el-row>
      <el-form-item>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>成果审核流程设置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-form-item>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="送审单位:" :label-width="formLabelWidth">
          <el-select
              v-model="feedFlowInfo.currentOrgInfo"
              filterable
              allow-create
              default-first-option
              placeholder="送审单位"
              style="min-width: 360px"
              @change="onChangeFeedOrg"
          >
            <el-option
                v-for="item in orgInfoList"
                :key="item.value"
                :label="item.label"
                :value="item"
            />
          </el-select>
          <el-button type="primary" @click="onEditfeedOrgInfoList">编辑</el-button>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="审核级别:" :label-width="formLabelWidth">
          <el-select v-model="feedFlowInfo.currentFlowLev"
                     default-first-option
                     placeholder="选择审核级别"
                     @change="onChangefeedLev"
          >
            <!--            <el-option label="指定人员" value="2"/>-->
            <!--            <el-option label="指定岗位" value="1"/>-->
            <el-option v-for="item in flowLevList"
                       :key="item.value"
                       :label="item.label"
                       :value="item"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item :label="feedFlowInfo.currentFlowLev.label+'方式:'" :label-width="formLabelWidth">
          <el-select v-model="feedFlowInfo.preVerifyStyle"
                     default-first-option
                     placeholder="设置审核方式"
                     @change="onChangeVerifyStyle"
          >
            <el-option v-for="item in verifyStyleList"
                       :key="item.value"
                       :label="item.label"
                       :value="item"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-form-item :label="feedFlowInfo.currentFlowLev.label+'配置:'" :label-width="formLabelWidth" style="width:100%">
        <el-button class="addVerifySetBtn" @click="addPreVerifySet" type="text">添加</el-button>
        <el-table
            style="width: 1200px"
            stripe
            ref="verifyTable"
            max-height="300"
            border="10px"
            :data="feedFlowInfo.preVerifySet"
        >
          <el-table-column :column-key="1" prop="orgID" label="单位ID" header-align="center" v-if="feedFlowInfo.preVerifyStyle.value==0">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="feedFlowInfo.preVerifySet[$index].orgID" placeholder="请输入名称"></el-input>
              <span v-show=false>{{column}}{{row}}</span>
            </template>
          </el-table-column>
          <el-table-column :column-key="2" prop="orgName" label="单位名称" header-align="center" min-width="100px" v-if="feedFlowInfo.preVerifyStyle.value==0">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="feedFlowInfo.preVerifySet[$index].orgName" placeholder="请输入名称"></el-input>
              <span v-show=false>{{column}}{{row}}</span>
            </template>
          </el-table-column>
          <el-table-column :column-key="3" prop="verifyerID" :label="feedFlowInfo.preVerifyStyle.label+'ID'" header-align="center">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="feedFlowInfo.preVerifySet[$index].verifyerID" placeholder="请输入名称"></el-input>
              <span v-show=false>{{column}}{{row}}</span>
            </template>
          </el-table-column>
          <el-table-column :column-key="4" prop="verifyerName" :label="feedFlowInfo.preVerifyStyle.label+'名称'" header-align="center">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="feedFlowInfo.preVerifySet[$index].verifyerName" placeholder="请输入名称"></el-input>
              <span v-show=false>{{column}}{{row}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column prop="isAdd" label="是否启用" header-align="center" width="100px">-->
<!--            <template #default="{row, column, $index }">-->
<!--              <el-switch v-model="feedFlowInfo.preVerifySet[$index].enabled"></el-switch>-->
<!--              <span v-show=false>{{column}}{{row}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column :column-key="5" prop="op" label="操作" header-align="center" width="80px">
            <template #default="scope" header-align="center" class="tableItem">
              <el-button
                  @click.prevent="deleteRow(scope.$index, this.feedFlowInfo.preVerifySet, true)"
                  type="text"
                  size="small">移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item style="text-align: right">
          <el-button type="primary" icon="el-icon-check" @click="onClickOk()">提交</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
<!--    附加对话框    -->
    <div v-dialogDrag>
      <dialog-ex
        v-model="feedOrgEditDlgVisible"
        title="送审单位管理"
        @closeMsg="feedOrgEditDlgVisible=false"
        width="650px"
        height="600px"
    >
      <template #body>
        <el-row>
          <el-select
              v-model="currentOrgInfoForEdit"
              filterable
              allow-create
              default-first-option
              placeholder="送审单位"
              style="min-width: 360px"
              @change="onChangeFeedOrggrpEdit"
          >
            <el-option
                v-for="item in orgInfoListForEdit"
                :key="item.value"
                :label="item.label"
                :value="item"
            />
          </el-select>
          <el-button type="primary" size="small" @click="addfeedOrgGrp">添加</el-button>
          <el-button type="primary" size="small" @click="delfeedOrgGrp">删除</el-button>
          <el-button type="primary" size="small" @click="updatefeedOrgGrp">编辑</el-button>
        </el-row>
        <el-row>
        <el-button class="addVerifySetBtn" @click="addfeedOrgInfoSet" type="text">设置</el-button>
          <el-table
              style="width: 100%"
              stripe
              max-height="150"
              border="10px"
              :data="orgInfoListByGrp">
            <el-table-column prop="name" label="单位ID" header-align="center">
              <template #default="{row, column, $index }">
                <el-input size="mini" v-model="orgInfoListByGrp[$index].value" placeholder="请输入名称"></el-input>
                <span v-show=false>{{column}}{{row}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="单位名称" header-align="center" min-width="100px">
              <template #default="{row, column, $index }">
                <el-input size="mini" v-model="orgInfoListByGrp[$index].label" placeholder="请输入名称"></el-input>
                <span v-show=false>{{column}}{{row}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" width="80px">
              <template #default="scope" header-align="center" class="tableItem">
                <el-button
                    @click.prevent="deleteRow(scope.$index, this.orgInfoListByGrp, false)"
                    type="text"
                    size="small">移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item style="text-align: right">
              <el-button type="primary" @click="onfeedOrgEditClickOk()">保存</el-button>
              <el-button type="primary" @click="feedOrgEditDlgVisible=false">关闭</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </dialog-ex>
    </div>
    <flow-chart v-on:selectChange="flowNodeSelChange" ref="flowChart"></flow-chart>
    <div>
      <el-drawer v-model="setOrgDrawer" direction="rtl" title="银行组织机构">
      <template #default>
        <div>
          <el-input
              placeholder="输入关键字进行过滤"
              v-model="bankOrgFilterText"
              style="width:80%">
          </el-input>
<!--          <el-button @click="setOrgDrawer=false">取消</el-button>-->
          <el-button type="primary" @click="confirmBankOrg">设置</el-button>
        </div>
        <el-progress
            :percentage="100"
            status="success"
            :indeterminate="true"
            :duration="5"
            v-if="bankOrgProgressVisible">加载中
        </el-progress>
        <el-scrollbar height="700px">
          <el-tree
              class="filter-tree"
              :data="bankOrgData"
              node-key="value"
              show-checkbox
              :default-expanded-keys="defexpandBankOrg"
              :default-checked-keys="defcheckedBankOrg"
              :filter-node-method="filterNode"
              ref="bankOrgTree">
            <template #default="{ node }">
              <span class="custom-tree-node">
                <i class="el-icon-s-home"></i><span>{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </template>
    </el-drawer>
      <el-drawer v-model="setEmpDrawer" direction="rtl" title="用户添加">
        <template #default>
          <div>
            <el-input
                placeholder="输入关键字进行过滤"
                v-model="empSearchText"
                v-on:keyup.enter = "searchEmp()"
                style="width:60%">
            </el-input>
            <el-button type="primary" @click="searchEmp">查询</el-button>
<!--            <el-button @click="setEmpDrawer=false">取消</el-button>-->
            <el-button type="primary" @click="confirmEmp">设置</el-button>
          </div>
          <el-progress
              :percentage="100"
              status="success"
              :indeterminate="true"
              :duration="5"
              v-if="empSearchProgressVisible">加载中
          </el-progress>
          <el-scrollbar height="700px">
            <el-tree
                class="filter-tree"
                :data="empSearchData"
                node-key="value"
                show-checkbox
                :filter-node-method="filterNode"
                ref="empSearchTree">
              <template #default="{ node }">
              <span class="custom-tree-node">
                <i class="el-icon-s-home"></i><span>{{ node.label }}</span>
              </span>
              </template>
            </el-tree>
          </el-scrollbar>
        </template>
      </el-drawer>
      <el-drawer v-model="setPositionDrawer" direction="rtl" title="岗位添加">
        <template #default>
          <div>
            <el-input
                placeholder="输入关键字进行过滤"
                v-model="posSearchText"
                v-on:keyup.enter = "searchPos()"
                style="width:60%">
            </el-input>
            <el-button type="primary" @click="searchPos">查询</el-button>
<!--            <el-button @click="setPositionDrawer=false">取消</el-button>-->
            <el-button type="primary" @click="confirmPos">设置</el-button>
          </div>
          <el-progress
              :percentage="100"
              status="success"
              :indeterminate="true"
              :duration="5"
              v-if="posSearchProgressVisible">加载中
          </el-progress>
          <el-scrollbar height="700px">
            <el-tree
                class="filter-tree"
                :data="posSearchData"
                node-key="value"
                show-checkbox
                :filter-node-method="filterNode"
                ref="posSearchTree">
              <template #default="{ node }">
              <span class="custom-tree-node">
                <i class="el-icon-s-home"></i><span>{{ node.label }}</span>
              </span>
              </template>
            </el-tree>
          </el-scrollbar>
        </template>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox} from "element-plus";
import DialogEx from "@/components/dialogEx";
import axios from "axios";
import FlowChart from "@/components/flowChart";

export default {
  components: {
    FlowChart,
    DialogEx
  },
  data() {
    return {
      posSearchText:"",
      empSearchText:"",
      posSearchData:[],
      empSearchData:[],
      bankOrgFilterText:"",
      empSearchProgressVisible: false,//银行组织机构对象 数据加载标识
      posSearchProgressVisible: false,//银行组织机构对象 数据加载标识
      bankOrgProgressVisible: false,//银行组织机构对象 数据加载标识
      defcheckedBankOrg: [],//默认勾选节点
      defexpandBankOrg: ["ORGATL100000274"],//默认展开节点
      bankOrgDataUrl:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankOrgs",
      empSearchDataUrl:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/empSearch",
      posSearchDataUrl:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/posSearch",
      bankOrgData:[],
      setOrgDrawer:false,
      setEmpDrawer:false,
      setPositionDrawer:false,
      curFlowInfoMap:{},
      curUserInfo:{},
      jwtStr:"",
      clientOrgMap:{},
      clientDatClassMap:{},
      clientAry:[],
      clientEditDlgVisible:false,
      feedOrgEditDlgVisible:false,
      feedDataClassEditDlgVisible:false,
      formLabelWidth: '80px',
      verifyStyleList:[{value:"0",label:"指定岗位"},{value:"1",label:"指定人员"}],
      flowLevList:[],
      clientInfoListForEdit:[],
      clientInfoList:[],
      orgInfoListForEdit:[],
      datClassListForEdit:[],
      orgInfoList:[],
      datClassList:[{value:"1",label:"生产数据"},{value:"2",label:"综合治理数据"}],
      orgInfoListByGrp:[],
      moduleInfoListByDatClass:[],
      currentOrgInfoForEdit:{},
      currentDatClassInfoForEdit:{},
      feedFlowInfo:{
        clientInfo:{},
        currentOrgInfo:{},
        currentFlowLev:{},
        preVerifyStyle:{},
        preVerifySet:[],
        currentDataClass:{}
        // finalVerifyStyle:{value:"1",label:"指定岗位"},
        // finalVerifySet:[{org_id:"ORGATL100001112",org_name:"开发处开发管理科",id:"POSITL110017997",name:"副科长"}]
      }
    }
  },
  mounted: function () {
    this.fetchUserInfo();
    if(this.curUserInfo != null)
    {
      this.fetchClientInfo(this.curUserInfo.employeeId,false,false,false);
    }
    //verifyStyleList,clientInfoList,orgInfoList,feedFlowInfo,map
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    searchPos(){
      let that = this;
      if(that.posSearchText.length>0){
        this.posSearchProgressVisible = true;
        axios({
          url: that.posSearchDataUrl+"?posname="+that.posSearchText,
          method: 'GET',
        }).then((res) => {
          if (res.status === 200) {
            that.posSearchData = res.data;
            this.posSearchProgressVisible = false;
            console.log(res);
          }
        }).catch((err) => {
          alert('Error');
          this.posSearchProgressVisible = false;
          console.log(err)
        })
      }
    },
    searchEmp(){
      let that = this;
      if(that.empSearchText.length>0){
        this.empSearchProgressVisible = true;
        axios({
          url: that.empSearchDataUrl+"?empname="+that.empSearchText,
          method: 'GET',
        }).then((res) => {
          if (res.status === 200) {
            that.empSearchData = res.data;
            this.empSearchProgressVisible = false;
            console.log(res);
          }
        }).catch((err) => {
          alert('Error');
          this.empSearchProgressVisible = false;
          console.log(err)
        })
      }
    },
    confirmEmp(){
      let addCheckEmp = this.$refs.empSearchTree.getCheckedNodes();
      let keyset = {};
      for(let i=0;i<this.feedFlowInfo.preVerifySet.length;i++){
        keyset[this.feedFlowInfo.preVerifySet[i].verifyerID] = this.feedFlowInfo.preVerifySet[i].verifyerName;
      }
      for(let j=0;j<addCheckEmp.length;j++){
        if(keyset[addCheckEmp[j].value] != undefined) continue;
        this.feedFlowInfo.preVerifySet.push({
          orgID:"",     //单位ID
          orgName:"",  //单位名称
          verifyerID:addCheckEmp[j].value,            //ID(岗位ID或雇员ID)
          verifyerName:addCheckEmp[j].EMPLOYEE_NAME          //名称(岗位名称或雇员名称)
        })
      }
      console.log("addCheckEmp:",addCheckEmp)
    },
    confirmPos(){
      let addCheckEmp = this.$refs.posSearchTree.getCheckedNodes();
      let keyset = {};
      for(let i=0;i<this.feedFlowInfo.preVerifySet.length;i++){
        keyset[this.feedFlowInfo.preVerifySet[i].verifyerID] = this.feedFlowInfo.preVerifySet[i].verifyerName;
      }
      for(let j=0;j<addCheckEmp.length;j++){
        if(keyset[addCheckEmp[j].value] != undefined) continue;
        this.feedFlowInfo.preVerifySet.push({
          orgID:addCheckEmp[j].ORG_ID,     //单位ID
          orgName:addCheckEmp[j].ORG_NAME,  //单位名称
          verifyerID:addCheckEmp[j].value,            //ID(岗位ID或雇员ID)
          verifyerName:addCheckEmp[j].POSITION_NAME          //名称(岗位名称或雇员名称)
        })
      }
      console.log("addCheckEmp:",addCheckEmp)
    },
    confirmBankOrg(){
      this.orgInfoListByGrp = this.$refs.bankOrgTree.getCheckedNodes();
      //this.orgInfoListByGrp.push({
            //   value:"",    //单位ID
            //   label:""     //单位名称
            // });
      console.log("checkBankOrgNodes:",this.orgInfoListByGrp)
    },
    flowNodeSelChange(selNode){
      let _this = this;
      if(selNode.node.id == "node2"){
        _this.feedFlowInfo.currentFlowLev = _this.flowLevList[0];
        _this.changeFeedLevOp(_this.feedFlowInfo.currentFlowLev,false)
      }
      else if(selNode.node.id == "node3"){
        _this.feedFlowInfo.currentFlowLev = _this.flowLevList[1];
        _this.changeFeedLevOp(_this.feedFlowInfo.currentFlowLev,false)
      }
    },
    initClientInfo(isInitClientInfo = true){
      let _this = this;
      _this.clientInfoList = [];
      for(let idx=0;idx<_this.clientAry.length;idx++)
      {
        _this.clientInfoList.push({value:_this.clientAry[idx].clientID,label:_this.clientAry[idx].clientName});
        if(idx==0 && isInitClientInfo){
          _this.feedFlowInfo.clientInfo = _this.clientInfoList[idx];
        }
      }
    },
    initOrgInfo(clientID, isInitOrgInfo = true){
      let _this = this;
      let orgList = _this.clientOrgMap[clientID];
      _this.orgInfoList = [];
      for(let idx=0;idx<orgList.length;idx++)
      {
        _this.orgInfoList.push({value:orgList[idx].grpOrgID,label:orgList[idx].grpOrgName})
        if(idx==0 && isInitOrgInfo)
        {
          _this.feedFlowInfo.currentOrgInfo = _this.orgInfoList[idx];
          _this.resetFlowInfo(this.curUserInfo.employeeId,clientID,_this.feedFlowInfo.currentOrgInfo.value,this.feedFlowInfo.currentDataClass.value);
        }
      }
      console.log(0,_this.orgInfoList)
    },
    initDatClassInfo(clientID, isInitDatClassInfo = true){
      let _this = this;
      let datClassList = _this.clientDatClassMap[clientID];
      _this.datClassList = [];
      for(let idx=0;idx<datClassList.length;idx++)
      {
        _this.datClassList.push({value:datClassList[idx].datClassID,label:datClassList[idx].datClassName})
        if(idx==0 && isInitDatClassInfo)
        {
          _this.feedFlowInfo.currentDataClass = _this.datClassList[idx];
          _this.resetFlowInfo(this.curUserInfo.employeeId,clientID,_this.feedFlowInfo.currentOrgInfo.value,this.feedFlowInfo.currentDataClass.value);
        }
      }
      console.log(0,_this.orgInfoList)
    },
    //刷新审核流程图状态
    resetFlowChartStatus(){
      let _this = this;
      if(_this.curFlowInfoMap["1"].flowInfo.length <=0){
        //置灰初审
        this.$refs.flowChart.setNodeStatus("node2",false);
        if(_this.curFlowInfoMap["2"].flowInfo.length <=0){
          //置灰终审
          this.$refs.flowChart.setNodeStatus("node3",false);
        }
        else{
          //置亮终审
          this.$refs.flowChart.setNodeStatus("node3",true);
        }
      }
      else{
        //置亮初审
        this.$refs.flowChart.setNodeStatus("node2",true);
        if(_this.curFlowInfoMap["2"].flowInfo.length <=0){
          //置灰终审
          this.$refs.flowChart.setNodeStatus("node3",false);
        }
        else{
          //置亮终审
          this.$refs.flowChart.setNodeStatus("node3",true);
        }
      }
      _this.$nextTick(() => {
        if (_this.feedFlowInfo.currentFlowLev.value == "1") {
          this.$refs.flowChart.setSelectNode("node2")
        } else if (_this.feedFlowInfo.currentFlowLev.value == "2") {
          this.$refs.flowChart.setSelectNode("node3")
        }
      }, 50);
    },
    initFlowInfo(){
      let curFlowLev = this.feedFlowInfo.currentFlowLev.value;

      if(this.curFlowInfoMap[curFlowLev] != null)
      {
        let levInfo = Object.assign({},this.curFlowInfoMap[curFlowLev].levInfo);
        this.feedFlowInfo.preVerifyStyle.value = levInfo.verifyStyle;
        this.feedFlowInfo.preVerifyStyle.label = levInfo.verifyStyleName;

        // this.feedFlowInfo.preVerifySet = Object.assign([],this.curFlowInfoMap[curFlowLev].flowInfo);
        this.feedFlowInfo.preVerifySet = this.curFlowInfoMap[curFlowLev].flowInfo.concat();
      }
      else{
        this.feedFlowInfo.preVerifyStyle = this.verifyStyleList[0];
        this.feedFlowInfo.preVerifySet = [];
      }
    },
    //根据当前参数获取流程信息
    resetFlowInfo(empID,clientID,grpOrgID,datClassID){
      console.log(datClassID)
      let _this = this;
      let submitData = new FormData();
      // submitData.append('clientID', clientID);
      submitData.append('grpOrgID', grpOrgID);
      // submitData.append('datClassID', datClassID);
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/flowInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: submitData
      }).then((res) => {
        if (res.status === 200) {
          _this.curFlowInfoMap = res.data.flowInfoMap;
          if(JSON.stringify(_this.curFlowInfoMap)=="{}")
          {
            _this.curFlowInfoMap[1] = {};
            _this.curFlowInfoMap[1].levInfo = {};
            _this.curFlowInfoMap[1].levInfo.verifyStyle = "0";
            _this.curFlowInfoMap[1].levInfo.verifyStyleName = "指定岗位",
            _this.curFlowInfoMap[1].flowInfo = [];
            _this.curFlowInfoMap[2] = {};
            _this.curFlowInfoMap[2].levInfo = {};
            _this.curFlowInfoMap[2].levInfo.verifyStyle = "0";
            _this.curFlowInfoMap[2].levInfo.verifyStyleName = "指定岗位",
            _this.curFlowInfoMap[2].flowInfo = [];
          }
          else if(_this.curFlowInfoMap[1] == undefined){
            _this.curFlowInfoMap[1] = {};
            _this.curFlowInfoMap[1].levInfo = {};
            _this.curFlowInfoMap[1].levInfo.verifyStyle = "0";
            _this.curFlowInfoMap[1].levInfo.verifyStyleName = "指定岗位",
            _this.curFlowInfoMap[1].flowInfo = [];
          }
          else if(_this.curFlowInfoMap[2] == undefined){
            _this.curFlowInfoMap[2] = {};
            _this.curFlowInfoMap[2].levInfo = {};
            _this.curFlowInfoMap[2].levInfo.verifyStyle = "0";
            _this.curFlowInfoMap[2].levInfo.verifyStyleName = "指定岗位",
            _this.curFlowInfoMap[2].flowInfo = [];
          }
          _this.initFlowInfo();
          _this.resetFlowChartStatus();
          console.log(11,_this.curFlowInfoMap)
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //获取审核级别信息
    fetchFlowTypeInfo(isInitFlowLev = true){
      let _this = this;
      let flowType = 'result';
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/getFlowTypeInfo?flowtype="+flowType,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          _this.flowLevList = res.data.flowAry;
          if(isInitFlowLev && _this.flowLevList.length>0)
            _this.feedFlowInfo.currentFlowLev = _this.flowLevList[0];
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    fetchUserInfo(){
      //获取用户信息
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      this.curUserInfo = userInfoSession.length > 0?JSON.parse(userInfoSession):null;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      this.jwtStr = jwtSession;
    },
    fetchClientInfo(empId,isSetGrpOrgEdit,isSetDefGrpOrgForEdit,isSetDataClassEdit) {
      console.log(isSetDataClassEdit)
      let _this = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/clientInfo",
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + _this.jwtStr
        }
      }).then((res) => {
        if (res.status === 200) {
          _this.clientAry = res.data.clientAry;
          _this.clientOrgMap = res.data.clientOrgMap;
          _this.clientDatClassMap = res.data.clientDatClassMap;

          _this.fetchFlowTypeInfo();
          _this.initClientInfo();
          if(_this.clientAry.length>0)
          {
            _this.initOrgInfo(_this.clientAry[0].clientID,false);
            // _this.initDatClassInfo(_this.clientAry[0].clientID,false);

            if(_this.orgInfoList.length>0){
              _this.feedFlowInfo.currentOrgInfo = _this.orgInfoList[0];
              _this.resetFlowInfo(this.curUserInfo.employeeId,_this.clientAry[0].clientID,_this.feedFlowInfo.currentOrgInfo.value,this.feedFlowInfo.currentDataClass.value);
            }
            // if(_this.datClassList.length>0) _this.feedFlowInfo.currentDataClass = _this.datClassList[0];
            // if(_this.orgInfoList.length>0 & _this.datClassList.length>0) _this.resetFlowInfo(this.curUserInfo.employeeId,_this.clientAry[0].clientID,_this.feedFlowInfo.currentOrgInfo.value,this.feedFlowInfo.currentDataClass.value);

            if(isSetGrpOrgEdit) _this.orgInfoListForEdit = Object.assign([],_this.orgInfoList);
            // if(isSetDataClassEdit){
            //   this.datClassListForEdit = Object.assign([],_this.datClassList);
            //   this.currentDatClassInfoForEdit = Object.assign({},_this.feedFlowInfo.currentDataClass);
            // }
            if(isSetDefGrpOrgForEdit && _this.orgInfoListForEdit.length>0){
              _this.currentOrgInfoForEdit = _this.orgInfoListForEdit[0];
              let clientID = _this.feedFlowInfo.clientInfo.value;
              _this.resetOrgInfobyGrp(clientID,_this.currentOrgInfoForEdit.value,false);
            }
          }
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    onEditfeedDatClassList() {
      let _this = this;
      this.datClassListForEdit = Object.assign([],_this.datClassList);//JSON.parse(JSON.stringify(_this.datClassList));
      this.currentDatClassInfoForEdit = Object.assign({},_this.feedFlowInfo.currentDataClass);//JSON.parse(JSON.stringify(_this.feedFlowInfo.currentDataClass));
      let clientID = _this.feedFlowInfo.clientInfo.value;
      let datClassID = _this.feedFlowInfo.currentDataClass.value;
      _this.resetDatClassInfobyGrp(clientID,datClassID,true);

      console.log("editDatClass");
    },
    resetDatClassInfobyGrp(clientID,datClassID,setEditDlgVisible){
      let _this = this;
      let submitData = new FormData();
      submitData.append('clientID', clientID);
      submitData.append('datClassID', datClassID);
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/feedDataClassInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: submitData
      }).then((res) => {
        if (res.status === 200) {
          let moduleList = res.data.moduleAry;
          _this.moduleInfoListByDatClass = [];
          for(let idx=0;idx<moduleList.length;idx++)
          {
            _this.moduleInfoListByDatClass.push({value:moduleList[idx].moduleID,label:moduleList[idx].moduleName})
          }
          // console.log(44,res.data,orgList.length,orgList,_this.orgInfoListByGrp)
          if(setEditDlgVisible){
            _this.feedDataClassEditDlgVisible = true;
          }
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    onEditfeedOrgInfoList() {
      let _this = this;
      this.orgInfoListForEdit = Object.assign([],_this.orgInfoList);
      this.currentOrgInfoForEdit = Object.assign({},_this.feedFlowInfo.currentOrgInfo);
      let clientID = _this.feedFlowInfo.clientInfo.value;
      let grpOrgID = _this.feedFlowInfo.currentOrgInfo.value;
      _this.resetOrgInfobyGrp(clientID,grpOrgID,true);

      console.log("editFeedOrg");
    },
    resetOrgInfobyGrp(clientID,grpOrgID,setEditDlgVisible){
      let _this = this;
      let submitData = new FormData();
      submitData.append('grpOrgID', grpOrgID);
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/orgInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: submitData
      }).then((res) => {
        if (res.status === 200) {
          let orgList = res.data.orgAry;
          _this.orgInfoListByGrp = [];
          for(let idx=0;idx<orgList.length;idx++)
          {
            _this.orgInfoListByGrp.push({value:orgList[idx].orgID,label:orgList[idx].orgName})
          }
          console.log(44,res.data,orgList.length,orgList,_this.orgInfoListByGrp)
          if(setEditDlgVisible){
            _this.feedOrgEditDlgVisible = true;
          }
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    onEditClientInfoList() {
      this.clientInfoListForEdit = Object.assign([],this.clientInfoList);
      this.clientEditDlgVisible = true;
      console.log("editClient");
    },
    //添加初审配置行
    addPreVerifySet(){
      if(this.feedFlowInfo.preVerifyStyle.value == "1"){
        this.setEmpDrawer = true;
      }
      else{
        this.setPositionDrawer = true;
      }
      // this.feedFlowInfo.preVerifySet.push({
      //   orgID:"",     //单位ID
      //   orgName:"",  //单位名称
      //   verifyerID:"",            //ID(岗位ID或雇员ID)
      //   verifyerName:""          //名称(岗位名称或雇员名称)
      // });
    },
    //添加项目信息行
    addClientInfoSet(){
      this.clientInfoListForEdit.push({
        value:"",     //单位ID
        label:""     //单位名称
      });
    },
    //添加项目信息行
    addfeedOrgInfoSet(){
      this.setOrgDrawer = true;
      this.bankOrgProgressVisible = false;
      if(this.bankOrgData.length == 0){
        if (this.orgInfoListByGrp.length > 0) {
          for (let i=0;i<this.orgInfoListByGrp.length;i++){
            this.defcheckedBankOrg.push(this.orgInfoListByGrp[i].value);
          }

          if (this.defcheckedBankOrg.length > 0)
            this.defexpandBankOrg = this.defcheckedBankOrg;
          console.log("defcheckOrg:",this.defcheckedBankOrg,this.bankOrgData);
        }
          // console.log("blkDataUrl:",this.blkDataUrl);
          let that = this;
          let jwtSession = localStorage.getItem("lyqtJwt");
          if (jwtSession == null) jwtSession = "";
        this.bankOrgProgressVisible = true;
          axios({
            url: that.bankOrgDataUrl,
            headers: {
              "Authorization": "Bearer " + jwtSession
            },
            method: 'GET',
          }).then((res) => {
            if (res.status === 200) {
              that.bankOrgData = res.data;
              this.bankOrgProgressVisible = false;
              console.log(res);
            }
          }).catch((err) => {
            alert('Error');
            this.bankOrgProgressVisible = false;
            console.log(err)
          })
      }
      else{
        if (this.orgInfoListByGrp.length > 0 && this.$refs.bankOrgTree != undefined) {
          for (let i=0;i<this.orgInfoListByGrp.length;i++){
            this.$refs.bankOrgTree.setChecked(this.orgInfoListByGrp[i].value,true,false)
            //this.defcheckedBankOrg.push(this.orgInfoListByGrp[i].value);
          }

          //if (this.defcheckedBankOrg.length > 0)
          //  this.defexpandBankOrg = this.defcheckedBankOrg;
          console.log("defcheckOrg:",this.defcheckedBankOrg,this.bankOrgData);
        }
      }
      // this.orgInfoListByGrp.push({
      //   value:"",    //单位ID
      //   label:""     //单位名称
      // });
    },
    //添加数据分类信息行
    addfeedDatClassInfoSet(){
      this.moduleInfoListByDatClass.push({
        value:"",     //数据分类ID
        label:""      //数据分类名称
      });
    },
    //删除行
    deleteRow(index, rows,needMsg) {
      if(needMsg)
      {
        ElMessageBox.confirm(
            '你真的要删除这一行数据吗',
            'warning', {
              confirmButtonText:"确认",
              cancelButtonText:"取消",
              type:"warning"
            }
        ).then(()=>{
          rows.splice(index, 1);
          ElMessage({type:"success",message:"删除成功"})
        }).catch(()=>{
          ElMessage({type:"info",message:"删除已取消"})
        })
      }
      else{
        rows.splice(index, 1);
      }

    },
    //项目编辑提交
    onClientEditClickOk() {
      let _this = this;
      _this.clientInfoList = Object.assign([],_this.clientInfoListForEdit);
      let clientDataList = [];
      for(let idx=0;idx<_this.clientInfoList.length;idx++)
      {
        clientDataList.push({clientID:_this.clientInfoList[idx].value,clientName:_this.clientInfoList[idx].label});
      }
      let clientDataObj = {};
      clientDataObj["clientList"] = clientDataList;
      let data = JSON.stringify(clientDataObj);
      console.log(data)
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/saveClientInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: data
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          if(res.data.status == "success")
          {
            if(_this.curUserInfo != null)
            {
              _this.fetchClientInfo(_this.curUserInfo.employeeId,false,false,false);
            }
          }
          ElMessage({type:"success",message:res.data.msg});
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //数据分类对应功能编辑提交
    onfeedDataClassClickOk() {
      let _this = this;
      // _this.orgInfoList = Object.assign([],_this.orgInfoListForEdit);
      _this.datClassInfoList = Object.assign([],_this.datClassListForEdit);
      let clientID = _this.feedFlowInfo.clientInfo.value;
      let datClassID = _this.currentDatClassInfoForEdit.value;
      let moduleList = [];
      for(let idx=0;idx<_this.moduleInfoListByDatClass.length;idx++)
      {
        moduleList.push({moduleID:_this.moduleInfoListByDatClass[idx].value,moduleName:_this.moduleInfoListByDatClass[idx].label});
      }
      let clientDataObj = {};
      clientDataObj["clientID"] = clientID;
      clientDataObj["datClassID"] = datClassID;
      clientDataObj["moduleList"] = moduleList;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/saveDatClassInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: clientDataObj
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          if(res.data.status == "success")
          {
            if(_this.curUserInfo != null)
            {
              _this.fetchClientInfo(_this.curUserInfo.employeeId,false,false,false);
            }
          }
          ElMessage({type:"success",message:res.data.msg});
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //反馈单位编辑提交
    onfeedOrgEditClickOk() {
      let _this = this;
      _this.orgInfoList = Object.assign([],_this.orgInfoListForEdit);
      let clientID = _this.feedFlowInfo.clientInfo.value;
      let grpOrgID = _this.currentOrgInfoForEdit.value;
      let orgDataList = [];
      for(let idx=0;idx<_this.orgInfoListByGrp.length;idx++)
      {
        orgDataList.push({orgID:_this.orgInfoListByGrp[idx].value,orgName:_this.orgInfoListByGrp[idx].label});
      }
      let clientDataObj = {};
      clientDataObj["clientID"] = clientID;
      clientDataObj["grpOrgID"] = grpOrgID;
      clientDataObj["orgList"] = orgDataList;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/saveOrgInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: clientDataObj
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          if(res.data.status == "success")
          {
            if(_this.curUserInfo != null)
            {
              _this.fetchClientInfo(_this.curUserInfo.employeeId,false,false,false);
            }
          }
          ElMessage({type:"success",message:res.data.msg});
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //审核级别变更
    onChangefeedLev(feedLevInfo){
      this.changeFeedLevOp(feedLevInfo,true);
    },
    changeFeedLevOp(feedLevInfo,isRefreshFlow){
      console.log(feedLevInfo)
      if(this.curFlowInfoMap[feedLevInfo.value] != undefined){
        let levObj = Object.assign({},this.curFlowInfoMap[feedLevInfo.value]);
        this.feedFlowInfo.preVerifySet = levObj.flowInfo;
        this.feedFlowInfo.preVerifyStyle = {"value":levObj.levInfo.verifyStyle,"label":levObj.levInfo.verifyStyleName}
      }
      else{
        this.feedFlowInfo.preVerifySet = [];
        // this.feedFlowInfo.preVerifyStyle = {"value":levObj.levInfo.verifyStyle,"label":levObj.levInfo.verifyStyleName}
      }
      if(isRefreshFlow)
      {
        if(feedLevInfo.value == "1"){
          this.$refs.flowChart.setSelectNode("node2")
        }
        else if(feedLevInfo.value == "2"){
          this.$refs.flowChart.setSelectNode("node3")
        }
      }
    },
    //项目分组编辑的分组信息编辑
    onChangeFeedOrggrpEdit(grpOrgInfo){
      let clientID = this.feedFlowInfo.clientInfo.value;
      if(this.$refs.bankOrgTree != undefined) {
        let checkedNodes = this.$refs.bankOrgTree.getCheckedNodes();
        for (let i = 0; i < checkedNodes.length; i++) {
          this.$refs.bankOrgTree.setChecked(checkedNodes[i].value, false, false);
        }
      }
      this.resetOrgInfobyGrp(clientID,grpOrgInfo.value,false);
    },
    //项目变更事件
    onChangeClient(clientInfo){
      this.initOrgInfo(clientInfo.value);
      this.initDatClassInfo(clientInfo.value);
      console.log("clientChange:",clientInfo);
    },
    //审核方式变更事件
    onChangeVerifyStyle(verifyStyle){
      let flowLev = this.feedFlowInfo.currentFlowLev.value;
      if(this.curFlowInfoMap[flowLev] != null){
        let levInfo = Object.assign({},this.curFlowInfoMap[flowLev].levInfo);
        if(levInfo.verifyStyle == verifyStyle.value)
        {
          // this.feedFlowInfo.preVerifySet = Object.assign([],this.curFlowInfoMap[flowLev].flowInfo);
          this.feedFlowInfo.preVerifySet = this.curFlowInfoMap[flowLev].flowInfo.concat();
        }
        else{
          this.feedFlowInfo.preVerifySet = [];
        }
      }
      this.$nextTick(()=>{
        this.$refs.verifyTable.doLayout();
      })
    },
    //当前项目分组变更
    onChangeFeedDatClass(datClassInfo){
      this.resetFlowInfo(this.curUserInfo.employeeId,this.feedFlowInfo.clientInfo.value,this.feedFlowInfo.currentOrgInfo.value, datClassInfo.value);
      console.log("feedDatClassChange:",datClassInfo);
    },
    //当前项目分组变更
    onChangeFeedOrg(orgInfo){
      this.resetFlowInfo(this.curUserInfo.employeeId,this.feedFlowInfo.clientInfo.value,orgInfo.value,this.feedFlowInfo.currentDataClass.value);
      console.log("feedOrgChange:",orgInfo);
    },
    //添加数据分类信息
    addfeedDatClassGrp(){
      let _this = this;
      ElMessageBox.prompt('请输入数据分类名称', '添加数据分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
          .then(({ value }) => {
            let data = {};
            data["clientID"] = _this.feedFlowInfo.clientInfo.value;
            data["dataClassName"] = value;
            axios({
              url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/addDatClassInfo",
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: data
            }).then((res) => {
              if (res.status === 200) {
                console.log(res);
                if(res.data.status == "success")
                {
                  if(_this.curUserInfo != null)
                  {
                    _this.fetchClientInfo(_this.curUserInfo.employeeId,false,false,true);
                  }
                }
                ElMessage({type:"success",message:res.data.msg});
              }
            }).catch((err) => {
              alert('Error');
              console.log(err)
            })
          })
          .catch(() => {
          })
    },
    //删除数据分类信息
    delfeedDatClassGrp() {
      let _this = this;
      ElMessageBox.confirm(
          '删除当前分组后，数据分类相关的审核流程将全部清空. 是否继续?',
          '注意',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            let data = {};
            data["clientID"] = _this.feedFlowInfo.clientInfo.value;
            data["dataClassID"] = _this.currentDatClassInfoForEdit.value;
            axios({
              url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/delDatClassInfo",
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: data
            }).then((res) => {
              if (res.status === 200) {
                console.log(res);
                if (res.data.status == "success") {
                  if (_this.curUserInfo != null) {
                    _this.fetchClientInfo(_this.curUserInfo.employeeId, false, false,true);
                  }
                }
                ElMessage({type: "success", message: res.data.msg});
              }
            }).catch((err) => {
              alert('Error');
              console.log(err)
            })
          })
          .catch(() => {
          })
    },
    //更新数据分类信息
    updatefeedDatClassGrp(){
      let _this = this;
      ElMessageBox.prompt('请输入更改后的数据分类名称', '编辑数据分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue:_this.currentDatClassInfoForEdit.label
      })
          .then(({ value }) => {
            let data = {};
            data["clientID"] = _this.feedFlowInfo.clientInfo.value;
            data["dataClassID"] = _this.currentDatClassInfoForEdit.value;
            data["dataClassName"] = value;
            axios({
              url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/updateDatClassInfo",
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: data
            }).then((res) => {
              if (res.status === 200) {
                console.log(res);
                if(res.data.status == "success")
                {
                  if(_this.curUserInfo != null)
                  {
                    // _this.fetchClientInfo(_this.curUserInfo.employeeId,false,false,true);
                    this.currentDatClassInfoForEdit = {value:res.data.content["dataClassID"],label:res.data.content["dataClassName"]};
                    for(let classIdx=0;classIdx<this.datClassListForEdit.length;classIdx++){
                      if(this.datClassListForEdit[classIdx].value == res.data.content["dataClassID"]){
                        this.datClassListForEdit[classIdx].label = res.data.content["dataClassName"];
                        break;
                      }
                    }
                    if(_this.clientDatClassMap[_this.feedFlowInfo.clientInfo.value] != undefined){
                      let dataClassList = _this.clientDatClassMap[_this.feedFlowInfo.clientInfo.value];
                      for(let classIdx=0;classIdx<dataClassList.length;classIdx++){
                        if(dataClassList[classIdx].datClassID == res.data.content["dataClassID"]){
                          _this.clientDatClassMap[_this.feedFlowInfo.clientInfo.value][classIdx].datClassName = res.data.content["dataClassName"];
                          break;
                        }
                      }
                    }
                    //
                    console.log(this.currentDatClassInfoForEdit,this.datClassListForEdit)
                  }
                }
                ElMessage({type:"success",message:res.data.msg});
              }
            }).catch((err) => {
              alert('Error');
              console.log(err)
            })
          })
          .catch(() => {
          })
    },
    //添加项目分组信息
    addfeedOrgGrp(){
      let _this = this;
      ElMessageBox.prompt('请输入送审单位分组名称', '添加送审单位分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
          .then(({ value }) => {
            let data = {};
            data["grpOrgName"] = value;
            axios({
              url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/addGrpInfo",
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: data
            }).then((res) => {
              if (res.status === 200) {
                console.log(res);
                if(res.data.status == "success")
                {
                  if(_this.curUserInfo != null)
                  {
                    _this.fetchClientInfo(_this.curUserInfo.employeeId,true,false,false);
                  }
                }
                ElMessage({type:"success",message:res.data.msg});
              }
            }).catch((err) => {
              alert('Error');
              console.log(err)
            })
          })
          .catch(() => {
          })
    },
    //删除项目分组信息
    delfeedOrgGrp() {
      let _this = this;
      ElMessageBox.confirm(
          '删除当前分组后，分组相关的审核流程将全部清空. 是否继续?',
          '注意',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            let data = {};
            data["grpOrgID"] = _this.currentOrgInfoForEdit.value;
            console.log("a",data);
            axios({
              url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/delGrpInfo",
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: data
            }).then((res) => {
              if (res.status === 200) {
                console.log(res);
                if (res.data.status == "success") {
                  if (_this.curUserInfo != null) {
                    _this.fetchClientInfo(_this.curUserInfo.employeeId, true, true,false);
                  }
                }
                ElMessage({type: "success", message: res.data.msg});
              }
            }).catch((err) => {
              alert('Error');
              console.log(err)
            })
          })
          .catch(() => {
          })
    },
    //更新项目分组信息
    updatefeedOrgGrp(){
      let _this = this;
      ElMessageBox.prompt('请输入更改后的送审单位分组名称', '编辑送审单位分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue:_this.currentOrgInfoForEdit.label
      })
        .then(({ value }) => {
          let data = {};
          data["grpOrgID"] = _this.currentOrgInfoForEdit.value;
          data["grpOrgName"] = value;
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/updateGrpInfo",
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + _this.jwtStr
            },
            data: data
          }).then((res) => {
            if (res.status === 200) {
              console.log(res);
              if(res.data.status == "success")
              {
                if(_this.curUserInfo != null)
                {
                  _this.fetchClientInfo(_this.curUserInfo.employeeId,true,false,false);
                  this.currentOrgInfoForEdit = {value:data["grpOrgID"],label:data["grpOrgName"]};
                }
              }
              ElMessage({type:"success",message:res.data.msg});
            }
          }).catch((err) => {
            alert('Error');
            console.log(err)
          })
        })
        .catch(() => {
        })
    },
    //保存项目分组对应的审核流程信息
    onClickOk() {
      let _this  = this
      console.log("begin",_this.orgInfoList,_this.orgInfoListForEdit)
      // _this.curFlowInfoMap
      //_this.orgInfoList = Object.assign([],_this.orgInfoListForEdit);
      console.log("begin",_this.orgInfoList)
      // let clientID = _this.feedFlowInfo.clientInfo.value;
      let grpOrgID = _this.feedFlowInfo.currentOrgInfo.value;
      // let datClassID = _this.feedFlowInfo.currentDataClass.value;
      if(grpOrgID.length<=0){
        ElMessage({type:"info",message:"送审单位为必填项，请检查后重试!"});
        return;
      }
      let flowList = [];
      // console.log("levOBJ1:",_this.flowLevList)
      for(let idx=0;idx<_this.flowLevList.length;idx++)
      {
        let verifyLev = _this.flowLevList[idx].value;
        let verifyStyle="",verifyStyleName="",verifyerList=[];
        if(verifyLev==_this.feedFlowInfo.currentFlowLev.value)
        {
          verifyStyle = _this.feedFlowInfo.preVerifyStyle.value;
          verifyStyleName = _this.feedFlowInfo.preVerifyStyle.label;
          verifyerList = _this.feedFlowInfo.preVerifySet;
        }
        else{
          if(!(JSON.stringify(_this.curFlowInfoMap)=="{}")){
            let levObj = _this.curFlowInfoMap[verifyLev];
            // console.log("levOBJ:",levObj,_this.curFlowInfoMap,verifyLev)
            if(levObj != undefined){
              verifyStyle = levObj.levInfo.verifyStyle;
              verifyStyleName = levObj.levInfo.verifyStyleName;
              verifyerList = levObj.flowInfo;
            }
          }
        }

        let flowInfo = {};
        flowInfo["verifyLev"] = verifyLev;
        flowInfo["verifyStyle"] = verifyStyle;
        flowInfo["verifyStyleName"] = verifyStyleName;
        flowInfo["verifyerList"] = verifyerList;
        // console.log(flowInfo)
        flowList.push(flowInfo);
      }
      let flowData={}
      flowData["grpOrgID"] = grpOrgID;
      flowData["flowList"] = flowList;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/flow/saveFlowInfo",
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: flowData
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          if(res.data.status == "success")
          {
            let verifyLev = _this.feedFlowInfo.currentFlowLev.value;
            if(JSON.stringify(_this.curFlowInfoMap)=="{}") {
              _this.curFlowInfoMap[verifyLev] = {};
              _this.curFlowInfoMap[verifyLev].levInfo = {};
              _this.curFlowInfoMap[verifyLev].flowInfo = [];
            }
            else if(_this.curFlowInfoMap[verifyLev] == undefined){
              _this.curFlowInfoMap[verifyLev] = {};
              _this.curFlowInfoMap[verifyLev].levInfo = {};
              _this.curFlowInfoMap[verifyLev].flowInfo = [];
            }
            _this.curFlowInfoMap[verifyLev].levInfo.verifyStyle = _this.feedFlowInfo.preVerifyStyle.value;
            _this.curFlowInfoMap[verifyLev].levInfo.verifyStyleName = _this.feedFlowInfo.preVerifyStyle.label;
            // _this.curFlowInfoMap[verifyLev].flowInfo = Object.assign([],_this.feedFlowInfo.preVerifySet);
            _this.curFlowInfoMap[verifyLev].flowInfo = _this.feedFlowInfo.preVerifySet.concat();
            console.log("end",_this.curFlowInfoMap)
          }
          _this.resetFlowChartStatus();
          ElMessage({type:"success",message:res.data.msg});
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    }
  },
  watch: {
    bankOrgFilterText(val) {
      this.$refs.bankOrgTree.filter(val);
    }
  }
}
</script>
<style lang="less">
.el-row {
  margin-bottom: 5px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 25px;
}
.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 25px;
}
.addVerifySetBtn{
  margin-left: 10px;
}
</style>